import {
  CalendlyCalendar,
  TCalendlyScheduledEvent
} from "../../components/Calendly";
import { useGetCalendlyHostIntakeMeetingUrl } from "../../components/Calendly/utils";
import { useContextHospi } from "../../context/ContextHospi";
import { useCallback, useEffect, useState } from "react";
import { useHospiNavigate } from "../../utils/common";
import { HOST_PROFILE_VIEW_ROUTE } from "../../utils/constants";
import { UserAPI } from "../../API/userApi";
import { useNotifier } from "../../context/ContextNotifier";
import { usePromisesLoader } from "../../utils/usePromiseLoader";
import {
  LoadingIndicator,
  LoadingIndicatorContainer
} from "../../components/LoadingIndicator";
import styled from "styled-components/macro";
import {
  StepDescription,
  StepTitle
} from "../../components/Wizard/Student/styles";

const Root = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
`;
const Title = styled(StepTitle)`
  margin-top: 24px;
  padding: 0 16px;
`;
const Description = styled(StepDescription)`
  margin-bottom: 0;
  padding: 0 16px;
`;
const Content = styled.div`
  position: relative;
  width: 100%;
  max-width: 700px;
`;
const CalendlyContainer = styled.div`
  position: relative;
`;
export const PlanIntakePage = () => {
  const { userProfile, cognitoUser, updateProfile } = useContextHospi();
  const meetingUrl = useGetCalendlyHostIntakeMeetingUrl();
  const navigate = useHospiNavigate();
  const notifier = useNotifier();
  const { isLoading, watchPromise } = usePromisesLoader();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (userProfile?.verification_status !== "unverified") {
      navigate(HOST_PROFILE_VIEW_ROUTE);
    }
  }, [userProfile?.verification_status]);

  return (
    <Root>
      <Content>
        <Title>Plan intake</Title>
        <Description>Plan intake</Description>
        <CalendlyContainer>
          <CalendlyCalendar
            meetingUrl={meetingUrl}
            userName={`${userProfile?.first_name ?? ""} ${
              userProfile?.last_name ?? ""
            }`}
            userEmail={cognitoUser?.email}
            onInitialized={useCallback(() => {
              setIsInitialized(true);
            }, [])}
            onEventScheduled={useCallback(
              (data: TCalendlyScheduledEvent) => {
                watchPromise(
                  UserAPI.requestVerification(
                    userProfile?.user_id!,
                    data.eventId
                  ).then((user) => {
                    updateProfile(user);
                    notifier.info({
                      message: "Intake planned"
                    });
                    navigate(HOST_PROFILE_VIEW_ROUTE);
                  })
                );
              },
              [navigate, notifier, userProfile?.user_id, watchPromise]
            )}
          />
          {isLoading || !isInitialized ? (
            <LoadingIndicatorContainer>
              <LoadingIndicator />
            </LoadingIndicatorContainer>
          ) : null}
        </CalendlyContainer>
      </Content>
    </Root>
  );
};
